import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import PageHeader from '../component/PageTabs'
import Header from '../component/Header'
import Footer from '../component/Footer'

const WithHeaderFooter = ({ children, smallCardAlignment = "" }) => {
  return (
    <>
      {/* <GlobalProvider> */}
      <div className="admin-layout">
        <Header />
        <div className="admin-content ">
          {/* custom-wrapper-height */}
          <div
            className={`w-full  flex items-center justify-center custom-h-100 align-center ${smallCardAlignment} `}
          >
            {children}
          </div>
        </div>
        <Footer />
      </div>
      {/* </GlobalProvider> */}
    </>
  );
};

export default React.memo(WithHeaderFooter);

